import { ErrorWithCode } from '@civic/civic-sign';

export default class CustomError extends Error {
  public nestedError: Error | ErrorWithCode | null;

  constructor(message: string, nestedError?: Error | ErrorWithCode) {
    super(message);
    this.nestedError = nestedError || null;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
